
const cssclass = (elemId, className, add) => {

//console.log("cssclass: elemId,classNamem,add;"+elemId+", "+className+", "+add);
if (!document.getElementById(elemId))	{
	console.log("abort cssclass.  elemId not found: "+elemId);
	return;
	}
	
	
if (add==1){
	if (!document.getElementById(elemId).classList.contains(className))
		document.getElementById(elemId).classList.add(className);	
	}//end if
else{
	if (document.getElementById(elemId).classList.contains(className))
		document.getElementById(elemId).classList.remove(className);	
	}//end if

};


export default cssclass;